module.exports = __webpack_public_path__ + "img/page3-2.1aa81b1d.png";